import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography, Button, Box } from '@material-ui/core';
import FlareIcon from '@material-ui/icons/Flare';

const useStyles = makeStyles(theme => ({
  card: {
    background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
    color: theme.palette.primary.contrastText,
    position: 'relative',
    overflow: 'hidden',
  },
  content: {
    padding: theme.spacing(4),
    position: 'relative',
    zIndex: 1,
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    marginBottom: theme.spacing(3),
    opacity: 0.9,
  },
  button: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    color: 'inherit',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
    },
  },
  iconContainer: {
    position: 'absolute',
    right: theme.spacing(4),
    top: '50%',
    transform: 'translateY(-50%)',
    opacity: 0.15,
  },
  icon: {
    fontSize: 150,
  },
  badge: {
    display: 'inline-block',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 16,
    fontSize: '0.75rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
}));

export const FeaturedSection = () => {
  const classes = useStyles();

  return (
    <Card className={classes.card} elevation={3}>
      <CardContent className={classes.content}>
        <Box className={classes.badge}>Featured</Box>
        <Typography variant="h4" className={classes.title}>
          Welcome to AI Central
        </Typography>
        <Typography variant="body1" className={classes.subtitle}>
          Your one-stop hub for AI resources, tools, and best practices at AvidXchange. 
          Explore our guides, stay updated with the latest AI news, and discover how to 
          leverage AI in your development workflow.
        </Typography>
        <Button
          variant="contained"
          className={classes.button}
          href="/docs/default/component/avid-developer-portal/ai-central/"
        >
          Explore AI Docs
        </Button>
      </CardContent>
      <Box className={classes.iconContainer}>
        <FlareIcon className={classes.icon} />
      </Box>
    </Card>
  );
};
